module.exports = __webpack_public_path__ + "16765ab13d2cb759af0fb27a7c1070d5.png";